module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "slider-item",
    on: {
      "click": _vm.onClick
    }
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "beforeenter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.animate) ? _c('div', {
    staticClass: "wrap"
  }, [_vm._t("default")], 2) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46960c62","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-item.pug
// module id = 593
// module chunks = 1